import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { BusinessAppearanceSettings } from '../../models/serializable/business-appearance-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BusinessAppearanceSettingsComponent extends Component {
  static readonly TYPE_ID: string = 'a5f8d5fded504966992d2227da66577f';

  constructor(
    public readonly settings: BusinessAppearanceSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessAppearanceSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessAppearanceSettingsComponent {
    return new BusinessAppearanceSettingsComponent(
        context.fromData<BusinessAppearanceSettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new BusinessAppearanceSettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: BusinessAppearanceSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class BusinessAppearanceSettingsComponentBuilder extends DataModelBuilder<BusinessAppearanceSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): BusinessAppearanceSettingsComponent {
    return BusinessAppearanceSettingsComponent.fromMap(context, map);
  }
}
